module.exports = __webpack_public_path__ + "img/check.e693e23e.png";